// src/components/video/NetworkIndicator.tsx
import React from 'react';
import './NetworkIndicator.css'; 

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons'; 
import { NetworkQuality } from '../../../../../interfaces/video/video';

interface NetworkIndicatorProps {
  quality: NetworkQuality;
  latency: number; // Latency in milliseconds
}

const NetworkIndicator: React.FC<NetworkIndicatorProps> = ({ quality, latency }) => {
  // This function determines the color and tooltip text based on the network quality
  const getStrengthDetails = () => {
    switch (quality) {
      case 'good':
        return { color: 'bg-success', title: `Excellent Connection | ${latency}ms` };
      case 'average':
        return { color: 'bg-warning', title: `Fair Connection | ${latency}ms` };
      case 'poor':
        return { color: 'bg-danger', title: latency < 0 ? 'Connection Unstable' : `Poor Connection | ${latency}ms` };
      default:
      case 'unknown':
        // For 'unknown', we don't need a color for the dot, but the title for the tooltip
        return { color: 'bg-secondary', title: 'Checking Connection...' };
    }
  };

  const { color, title } = getStrengthDetails();

  // Determine if we should show the spinner
  const showSpinner = quality === 'unknown';

  return (
    <div
        className="absolute top-2 right-2 flex items-center justify-center"
        title={title} 
    >
      {showSpinner ? (
        <div className="spinner text-white" style={{ width: '12px', height: '12px' }}></div>
      ) : (
        // Colored circle for determined quality
        <div
          className={`rounded-full ${color}`}
          style={{ width: '12px', height: '12px', transition: 'background-color 0.3s ease' }}
        ></div>
      )}
    </div>
  );
};

export default NetworkIndicator;